/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Quote_4_TextInputs */

const da_forside_quote_4_text = /** @type {(inputs: Forside_Quote_4_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeg var skeptisk over for AI og karakterer. Men jeg sidder stadig med det sidste ord – den kommer bare med et godt første udkast.`)
};

/** @type {(inputs: Forside_Quote_4_TextInputs) => LocalizedString} */
const en_forside_quote_4_text = da_forside_quote_4_text;

/**

* @param {Forside_Quote_4_TextInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_quote_4_text = /** @type {((inputs?: Forside_Quote_4_TextInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Quote_4_TextInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_quote_4_text(inputs)
	return /** @type {LocalizedString} */ ("Jeg var skeptisk over for AI og karakterer. Men jeg sidder stadig med det sidste ord – den kommer bare med et godt første udkast.")
});